export const RESET = "reset";
export const UPDATE_NOTIFICATIONS = "updateNotifications";
export const ADD_NOTIFICATION = "addNotification";
export const SET_NOTIFICATIONS = "setNotifications";
export const DELETE_NOTIFICATIONS = "deleteNotifications";
export const UPDATE_HAS_NEW_NOTIFICATIONS = "updateHasNewNotifications";
